import React from 'react';
import { X } from 'lucide-react';
import { Cut } from './Cut';

// Status is a word plus a dot — never colour alone. Errors say what happened and what to do.
export const PlaybackNotice = ({ note, failed, onRetry, onDismiss, testId }) => {
  if (!note && !failed) return null;
  return (
    <Cut size="sm" glass={false} className="th-rise" data-testid={testId}>
      <div className="flex items-center gap-3 px-4 py-2.5">
        <span className="w-1.5 h-1.5 flex-shrink-0" style={{ background: 'var(--th-accent)' }} />
        <span className="flex-1 th-caption" style={{ color: 'var(--th-text)' }}>
          {failed ? (note || 'This film could not be played on your connection. Try again, or move to the next film.') : note}
        </span>
        {failed && (
          <button type="button" onClick={onRetry} className="th-label text-[10px] px-3 py-1.5 th-cut th-cut-sm" style={{ background: 'var(--th-accent)', color: 'var(--th-cinema)' }} data-testid="film-retry-btn">Retry</button>
        )}
        <button type="button" onClick={onDismiss} aria-label="Dismiss" className="th-icon-btn w-8 h-8" data-testid="film-notice-dismiss-btn"><X size={14} /></button>
      </div>
    </Cut>
  );
};

export const SoundPrompt = ({ onEnable }) => (
  <button type="button" onClick={onEnable} className="th-frame th-cut th-cut-sm inline-flex is-active th-rise" data-testid="film-sound-prompt">
    <span className="th-cut th-cut-sm th-solid th-label text-[10px] px-4 py-2.5 flex items-center gap-2" style={{ color: 'var(--th-accent-soft)' }}>
      <span className="w-1 h-1" style={{ background: 'var(--th-accent)' }} />Tap for sound
    </span>
  </button>
);
